<template>
  <div id="activeCenters" class="tab-content">
    <div class="filter-box mb-3">
      <centers-filter-form
        v-model="searchFields"
        :platform-attribute-filters="platformAttributeFilters"
        @search="search"
      />
    </div>

    <centers-table
      :centers="centers"
      :loading="loading"
      :current-sort-by="searchFields.sort_by"
      :sort-order="searchFields.sort_order"
      :show-region="true"
      :show-deleted-at="centerType !== 'active'"
      :highlighted-id="searchFields.lastVisitedId"
      @sort="sortBy"
      @open="openCenter"
    />

    <div class="row-fluid float-right">
      <DerPaginate
        v-model="meta.current_page"
        :page-count="meta.last_page"
        :show-go="true"
        @change="getCenters"
      />
    </div>
  </div>
</template>

<script>
import DerPaginate from "../../../../design-system/DerPaginate.vue";
import CentersFilterForm from "../CentersFilterForm.vue";
import CentersTable from "../CentersTable.vue";
import { queryStringBuilder } from "../../../../helpers/misc";

export default {
  components: { DerPaginate, CentersFilterForm, CentersTable },
  props: {
    centerType: String,
  },
  data() {
    return {
      loading: true,
      centers: [],
      meta: {
        current_page: 1,
        last_page: 1,
      },
      platformAttributeFilters: [],
      searchFields: {
        page: 1,
        name: null,
        hsa_id: null,
        product_id: null,
        feature_id: null,
        platformAttributes: {},
        created_from: null,
        created_to: null,
        sort_by: "name",
        sort_order: "asc",
        lastVisitedId: null,
      },
    };
  },
  created() {
    this.loadState();
    this.fetchPlatformAttributeFilters();
    this.getCenters();
  },
  methods: {
    loadState() {
      const stored = localStorage.getItem(`${this.centerType}_centers`);
      if (!stored) return;
      const parsed = JSON.parse(stored);
      this.searchFields = {
        ...this.searchFields,
        ...parsed,
        platformAttributes: parsed.platformAttributes || {},
      };
    },
    saveState() {
      localStorage.setItem(
        `${this.centerType}_centers`,
        JSON.stringify(this.searchFields),
      );
    },
    fetchPlatformAttributeFilters() {
      axios
        .get("/api/internal/admin/platform-attribute-filters")
        .then((res) => {
          const raw = res.data.platformAttributeFilters || [];
          this.platformAttributeFilters = raw.map((item) => ({
            name: item.name,
          }));

          const existing = this.searchFields.platformAttributes || {};
          const next = {};
          this.platformAttributeFilters.forEach((f) => {
            next[f.name] =
              existing[f.name] !== undefined ? existing[f.name] : "";
          });
          this.searchFields = {
            ...this.searchFields,
            platformAttributes: next,
          };
        })
        .catch(() => {
          this.platformAttributeFilters = [];
        });
    },
    getCenters(page = 1) {
      this.loading = true;
      this.searchFields.page = page;
      this.saveState();

      const type = this.centerType === "active" ? "centers" : "deleted-centers";

      axios
        .get(
          `/api/internal/admin/${type}?${queryStringBuilder(
            this.searchFields,
          )}`,
        )
        .then((res) => {
          const collection = res.data;
          this.centers = collection.data;
          this.meta = collection.meta;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.userErrorMessage(err);
        });
    },
    search() {
      this.getCenters(1);
    },
    openCenter(id) {
      this.$router.push({ name: "AdminCentersEdit", params: { id } });
      this.searchFields.lastVisitedId = id;
      this.saveState();
    },
    sortBy(column) {
      if (this.searchFields.sort_by === column) {
        this.searchFields.sort_order =
          this.searchFields.sort_order === "asc" ? "desc" : "asc";
      } else {
        this.searchFields.sort_by = column;
        this.searchFields.sort_order = "asc";
      }
      this.getCenters(1);
    },
  },
};
</script>

<style scoped>
.filter-box {
  background: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 0.5rem;
  padding: 1rem 1rem 1.25rem 1rem;
}
</style>
